import { render, staticRenderFns } from "./ReportBoxTrendVendors.vue?vue&type=template&id=18bd8952&"
import script from "./ReportBoxTrendVendors.vue?vue&type=script&lang=js&"
export * from "./ReportBoxTrendVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18bd8952')) {
      api.createRecord('18bd8952', component.options)
    } else {
      api.reload('18bd8952', component.options)
    }
    module.hot.accept("./ReportBoxTrendVendors.vue?vue&type=template&id=18bd8952&", function () {
      api.rerender('18bd8952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/ReportBoxTrendVendors.vue"
export default component.exports